import { render, staticRenderFns } from "./NotificationPopUpModal.vue?vue&type=template&id=5fde2112&scoped=true"
import script from "./NotificationPopUpModal.vue?vue&type=script&lang=js"
export * from "./NotificationPopUpModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationPopUpModal.vue?vue&type=style&index=0&id=5fde2112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fde2112",
  null
  
)

export default component.exports